import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button, Image } from 'react-bootstrap';
import industriesData from './data/industries';
import Select from 'react-select';
import icIndustry from './assets/img/ic-factory.svg';

const CountryIndustries = ({
    // ✅ Edit-page style props (optional)
    industries,
    onAddIndustry,
    onRemoveIndustry,
    onIndustryChange,
    onAddSubIndustry2,
    handleIndustriesSubmit,
    isEditPage,
    errors,

    // ✅ Add-page style props (optional)
    formData,
    handleChange,
}) => {
    const [isEditing, setIsEditing] = useState(!isEditPage);

    const industriesListRaw = Array.isArray(industries)
    ? industries
    : Array.isArray(formData?.industries)
    ? formData.industries
    : [];

    const industriesList = industriesListRaw.length
        ? industriesListRaw
        : [{ industry: '', subIndustry: [], subIndustry2: [] }];

    // ✅ one setter that works for Add flow (formData) or Edit flow (external handlers)
    const setIndustriesList = (next) => {
        if (typeof handleChange === 'function') {
            handleChange({ target: { name: 'industries', value: next } });
        }
    };

    const [tempIndustries, setTempIndustries] = useState(() => {
        const base = industriesList;
        return typeof structuredClone === 'function'
            ? structuredClone(base)
            : JSON.parse(JSON.stringify(base));
    });

    useEffect(() => {
        if (!isEditing) {
            const base = industriesList;
            setTempIndustries(
                typeof structuredClone === 'function'
                    ? structuredClone(base)
                    : JSON.parse(JSON.stringify(base))
            );
        }
    }, [industriesList, isEditing]);


    // ✅ Fallback handlers for ADD flow (when onAddIndustry / onIndustryChange aren’t passed)
    const _onAddIndustry =
        typeof onAddIndustry === 'function'
            ? onAddIndustry
            : () => {
                const next = [
                    ...industriesList,
                    { industry: '', subIndustry: [], subIndustry2: [] },
                ];
                setIndustriesList(next);
            };

    const _onRemoveIndustry =
        typeof onRemoveIndustry === 'function'
            ? onRemoveIndustry
            : (index) => {
                const next = industriesList.filter((_, i) => i !== index);
                setIndustriesList(next);
            };

    const _onIndustryChange =
        typeof onIndustryChange === 'function'
            ? onIndustryChange
            : (index, field, value) => {
                const next = industriesList.map((item, i) => {
                    if (i !== index) return item;
                    return {
                        ...item,
                        [field]: value,
                    };
                });
                setIndustriesList(next);
            };


    const handleEditClick = () => {
        setIsEditing(true);

        const base = industriesList;
        setTempIndustries(
            typeof structuredClone === 'function'
                ? structuredClone(base)
                : JSON.parse(JSON.stringify(base))
        );
    };

    const handleSaveClick = async (e) => {
        e.preventDefault();
        if (typeof handleIndustriesSubmit === 'function') {
            await handleIndustriesSubmit(e);
            setIsEditing(false);
        } else {
            console.error('Error: handleIndustriesSubmit is not a function.');
        }
    };

    const handleCancelClick = () => {
        setIsEditing(false);

        const restored = Array.isArray(tempIndustries) ? tempIndustries : [];

        // ✅ Add-flow: just restore industries array
        if (typeof handleChange === 'function') {
            setIndustriesList(restored);
            return;
        }

        // ✅ Edit-flow: restore using passed handler
        restored.forEach((industry, index) => {
            _onIndustryChange(index, 'industry', industry?.industry || '');
            _onIndustryChange(index, 'subIndustry', Array.isArray(industry?.subIndustry) ? industry.subIndustry : []);
            _onIndustryChange(index, 'subIndustry2', Array.isArray(industry?.subIndustry2) ? industry.subIndustry2 : []);
        });
    };

    return (
        <>
            <Card className="mb-4">
                <Card.Body>
                    <Row>
                        <Col md={12}>
                            {isEditPage && (
                                <div className="float-end">
                                    {!isEditing ? (
                                        <Button
                                            type="button"
                                            variant="outline-secondary"
                                            className="btn-sm"
                                            onClick={handleEditClick}
                                        >
                                            Edit
                                        </Button>
                                    ) : (
                                        <>
                                            <Button
                                                type="button"
                                                variant="outline-secondary"
                                                className="btn-sm me-2"
                                                onClick={handleCancelClick}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                type="button"
                                                variant="primary"
                                                className="btn-sm"
                                                onClick={handleSaveClick}
                                            >
                                                Save
                                            </Button>
                                        </>
                                    )}
                                </div>
                            )}
                            <h3>
                                <span className="item-number">7. </span>
                                Industries &amp; Career
                            </h3>
                            <hr />
                        </Col>
                    </Row>

                    {industriesList.map((industry, index) => {
                        const selectedIndustry = industriesData.find(
                            (ind) => ind.code === industry.industry
                        );

                        return (
                            <React.Fragment key={index}>
                                {isEditing ? (
                                    <>
                                        <Card className="mb-4">
                                            <Card.Body>
                                                <Row className="mb-3">
                                                    <Col md={12}>
                                                        <label>Industry {index + 1}</label>
                                                        <Select
                                                            options={industriesData.map((ind) => ({
                                                                value: ind.code,
                                                                label: ind.name,
                                                            }))}
                                                            value={
                                                                industry.industry
                                                                    ? {
                                                                          value: industry.industry,
                                                                          label:
                                                                              industriesData.find(
                                                                                  (ind) =>
                                                                                      ind.code ===
                                                                                      industry.industry
                                                                              )?.name || '',
                                                                      }
                                                                    : null
                                                            }
                                                            onChange={(selected) => {
                                                                if (!isEditing) return;

                                                                const nextIndustry = selected?.value || '';

                                                                // ✅ EDIT flow: parent can handle multiple functional updates safely
                                                                if (typeof onIndustryChange === 'function') {
                                                                    onIndustryChange(index, 'industry', nextIndustry);
                                                                    onIndustryChange(index, 'subIndustry', []);
                                                                    onIndustryChange(index, 'subIndustry2', []);
                                                                    return;
                                                                }

                                                                // ✅ ADD flow: must update in ONE shot (avoid stale industriesList overwrites)
                                                                const next = industriesList.map((item, i) => {
                                                                    if (i !== index) return item;
                                                                    return {
                                                                        ...item,
                                                                        industry: nextIndustry,
                                                                        subIndustry: [],
                                                                        subIndustry2: [],
                                                                    };
                                                                });

                                                                setIndustriesList(next);
                                                            }}
                                                            isClearable
                                                            isDisabled={!isEditing}
                                                            className="react-select"
                                                            classNamePrefix="react-select"
                                                            isInvalid={
                                                                errors &&
                                                                Array.isArray(errors.industries) &&
                                                                !!errors.industries[index]
                                                            }
                                                        />
                                                    </Col>
                                                    {errors &&
                                                        Array.isArray(errors.industries) &&
                                                        errors.industries[index] && (
                                                            <div className="text-danger small mt-1">
                                                                {errors.industries[index]}
                                                            </div>
                                                        )}
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col md={12}>
                                                        <label>Sub industry</label>
                                                        <Select
                                                            options={
                                                                selectedIndustry
                                                                    ? selectedIndustry.subIndustries.flatMap(
                                                                          (sub) => [
                                                                              {
                                                                                  value: sub.code,
                                                                                  label: sub.name,
                                                                              },
                                                                              ...(sub.subSubIndustries ||
                                                                                  []
                                                                              ).map((subSub) => ({
                                                                                  value: subSub.code,
                                                                                  label: `- ${subSub.name}`,
                                                                              })),
                                                                          ]
                                                                      )
                                                                    : []
                                                            }
                                                            value={(
                                                                Array.isArray(
                                                                    industry.subIndustry
                                                                )
                                                                    ? industry.subIndustry
                                                                    : []
                                                            )
                                                                .map((subCode) =>
                                                                    selectedIndustry?.subIndustries
                                                                        .flatMap((sub) => [
                                                                            {
                                                                                value: sub.code,
                                                                                label: sub.name,
                                                                            },
                                                                            ...(sub.subSubIndustries ||
                                                                                []
                                                                            ).map((subSub) => ({
                                                                                value: subSub.code,
                                                                                label: `- ${subSub.name}`,
                                                                            })),
                                                                        ])
                                                                        .find(
                                                                            (option) =>
                                                                                option.value ===
                                                                                subCode
                                                                        )
                                                                )
                                                                .filter(Boolean)}
                                                            onChange={(selected) => {
                                                                if (!isEditing) return;

                                                                const nextSub = Array.isArray(selected) ? selected.map((s) => s.value) : [];

                                                                // ✅ EDIT flow
                                                                if (typeof onIndustryChange === 'function') {
                                                                    onIndustryChange(index, 'subIndustry', nextSub);
                                                                    return;
                                                                }

                                                                // ✅ ADD flow (one shot)
                                                                const next = industriesList.map((item, i) => {
                                                                    if (i !== index) return item;
                                                                    return {
                                                                        ...item,
                                                                        subIndustry: nextSub,
                                                                    };
                                                                });

                                                                setIndustriesList(next);
                                                            }}
                                                            isMulti
                                                            isClearable
                                                            isDisabled={!isEditing}
                                                            className="react-select"
                                                            classNamePrefix="react-select"
                                                        />
                                                    </Col>
                                                </Row>

                                                {index > 0 && (
                                                    <Row>
                                                        <Col className="text-end">
                                                            <Button
                                                                type="button"
                                                                variant="link"
                                                                size="sm"
                                                                onClick={() => _onRemoveIndustry(index)}
                                                                className="align-center text-danger p-0"
                                                            >
                                                                Remove industry
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </>
                                ) : (
                                    // read-only view
                                    <>
                                        {industry.industry && (
                                            <>
                                                <Row>
                                                    <Col md={12}>
                                                        <Card>
                                                            <Card.Body className="p-3">
                                                                <div className="icon-text">
                                                                    <span
                                                                        className="icon"
                                                                        aria-hidden="true"
                                                                    >
                                                                        <Image
                                                                            src={icIndustry}
                                                                            alt="Industry"
                                                                        />
                                                                    </span>
                                                                    <span className="text">
                                                                        Which sectors does the target
                                                                        country consider to be key
                                                                        industries?
                                                                        <br />
                                                                        <strong>
                                                                            {industriesData.find(
                                                                                (ind) =>
                                                                                    ind.code ===
                                                                                    industry.industry
                                                                            )?.name || 'N/A'}
                                                                        </strong>
                                                                    </span>
                                                                </div>
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                </Row>

                                                <Row className="sub-card-row">
                                                    <Col md={12}>
                                                        <Card>
                                                            <Card.Body>
                                                                <div className="icon-text">
                                                                    <span
                                                                        className="icon"
                                                                        aria-hidden="true"
                                                                    >
                                                                        <Image
                                                                            src={icIndustry}
                                                                            alt="Industry"
                                                                        />
                                                                    </span>
                                                                    <span className="text">
                                                                        Sub industry:
                                                                        <br />
                                                                        <strong>
                                                                            {Array.isArray(
                                                                                industry.subIndustry
                                                                            ) &&
                                                                            industry.subIndustry
                                                                                .length > 0
                                                                                ? industry.subIndustry
                                                                                      .map(
                                                                                          (code) => {
                                                                                              const sub =
                                                                                                  selectedIndustry?.subIndustries?.find(
                                                                                                      (s) =>
                                                                                                          s.code ===
                                                                                                          code
                                                                                                  );
                                                                                              if (sub)
                                                                                                  return sub.name;

                                                                                              const subSub =
                                                                                                  selectedIndustry?.subIndustries
                                                                                                      ?.flatMap(
                                                                                                          (s) =>
                                                                                                              s.subSubIndustries ||
                                                                                                              []
                                                                                                      )
                                                                                                      .find(
                                                                                                          (ss) =>
                                                                                                              ss.code ===
                                                                                                              code
                                                                                                      );
                                                                                              if (subSub)
                                                                                                  return subSub.name;

                                                                                              return null;
                                                                                          }
                                                                                      )
                                                                                      .filter(Boolean)
                                                                                      .join(', ')
                                                                                : 'N/A'}
                                                                        </strong>
                                                                    </span>
                                                                </div>
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    </>
                                )}
                            </React.Fragment>
                        );
                    })}

                    {isEditing && (
                        <Row>
                            <Col md={12} className="justify-content-end d-flex">
                                <Button
                                    type="button"
                                    variant="primary"
                                    onClick={_onAddIndustry}
                                    className="btn-sm"
                                >
                                    Add a new industry
                                </Button>
                            </Col>
                        </Row>
                    )}
                </Card.Body>
            </Card>
        </>
    );
};

export default CountryIndustries;
